import moment from "moment";

const importLog = {
    namespaced: true,
    state: {
        importLogDays:[],
        selectedDayLogs:[],
        selectedDay:null
    },
    mutations: {
        updateImportLogDaysList(state , newList ) {
            state.importLogDays = newList;
        },
        updateSelectedDayLogs(state , newList ) {
            state.selectedDayLogs = newList;
        },
        updateSelectedDay( state , day ) {
            state.selectedDay = day;
        }
    },
    actions: {
        getImportLogDaysList(context) {
            this._vm.$traveller_http.get('/traveller/restui/importlog/getimportlogdays')
            .then(response => {
                context.commit('updateImportLogDaysList' , response.data )
            })
        },
        setSelectedDay(context, day ) {
            
            var startTime = moment(day); //new Date( Date.parse(day) );
            var endTime =  moment(day); //new Date( startTime.getTime() );
            //endTime.setDate( startTime.getDate() +1 );
            endTime.add(1 , 'days');
            const params = new URLSearchParams();
            params.append('from' , startTime.toISOString() );
            params.append('to' , endTime.toISOString() );
            this._vm.$traveller_http.post('/traveller/restui/importlog/getimportlogs' ,params )
            .then( response => {
                context.commit('updateSelectedDayLogs' , response.data );
                context.commit('updateSelectedDay' , startTime );
            } )
        }
    }
}

export default importLog;